<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="driver-box">
        <div class="d-title">We found you a driver!</div>
        <div class="d-rsvp">RSVP ID: {{ rsvpId }}</div>
        <div class="d-flex d-box align-start drvr">
          <img :src="driver.img" />
          <div class="d-info">
            <label>ID:</label>
            <div>{{ driver.id }}</div>
            <label>Name:</label>
            <div>{{ driver.name }}</div>
            <label v-if="driver.mobile">Mobile:</label>
            <div v-if="driver.mobile">{{ driver.mobile }}</div>
            <label>Rating:</label>
            <div>{{ driver.rating }}</div>
          </div>
        </div>
        <div class="d-flex d-box align-start">
          <img :src="vehicle.img" />
          <div class="d-info">
            <label>Model:</label>
            <div>{{ `${vehicle.year} ${vehicle.make} ${vehicle.model}` }}</div>
            <label>License Plate:</label>
            <div>{{ vehicle.licensePlate }}</div>
            <label>Color:</label>
            <div>{{ vehicle.color }}</div>
          </div>
        </div>
        <a class="op-btn btn-block btn-success" @click="close">Close</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'asap-success',
  data () {
    return {
    }
  },
  computed: {
    asapSuccess () { return this.$store.state.global.asapSuccess },
    show: {
      get () { return this.asapSuccess.show },
      set (x) {
        this.$store.commit('global/setAsapSuccessData', {show: x})
      }
    },
    rsvpId () { return this.asapSuccess.rsvpId },
    driver () { return this.asapSuccess.driver },
    vehicle () { return this.asapSuccess.vehicle }
  },
  methods: {
    close () {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;
  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    width: 100%;
    max-width: 500px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;
    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
}
.d-box{
  text-align: left;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, .15);
  background: #fafafa;
  border: 1px solid #ddd;
  padding: 10px;
  gap: 15px;
}
.d-title{
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  text-align: center;
}
.d-rsvp{
  text-align: left;
  margin-bottom: 10px;
  letter-spacing: .7px;
  background: #d7fdcb;
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  color: #333;
  border: 1px solid #39ab2b;
  border-radius: 2px;
}
.d-box{
  &.drvr{
    margin-bottom: 20px;
    border-bottom: 1px dashed #eee;
  }
  img{
    width: 180px;
  }
  .d-info{
    width: calc(100% - 180px);
    text-align: left;
    line-height: 1;
    label{
      color: #555;
      font-size: 12px;
      letter-spacing: .7px;
      display: inline-block;
      margin-bottom: 2px;
    }
    div{
      font-weight: 600;
      margin-bottom: 8px;
      font-size: 17px;
    }
  }
}
.btn-success{
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// AsapSuccess.vue?6d5ffb37